// @flow

import styled from '@emotion/styled'
import * as React from 'react'

import { Input } from '../form/Input'
import { IconPswHidden } from '../icons/IconPswHidden'
import { IconPswVisible } from '../icons/IconPswVisible'

import { LabelWrapper } from './styles'

type PasswordProps = {
  ...React.ElementConfig<'input'>,
  className?: string,
  label?: React.Node,
  error?: React.Node,
  id: string,
  name: string,
  onChange?: (e: SyntheticInputEvent<HTMLInputElement>) => void,
  onBlur?: (e: SyntheticInputEvent<HTMLInputElement>) => void,
  placeholder?: string,
  value?: string,
  disabled?: boolean,
  readonly?: boolean,
}

export const Password = ({
  className,
  label,
  error,
  ...props
}: PasswordProps) => {
  const [isVisible, setIsVisible] = React.useState(false)

  return (
    <LabelWrapper className={className} label={label} error={error}>
      <StyledPasswordWrapper isVisible={isVisible}>
        <Input
          {...{
            ...props,
            type: isVisible ? 'text' : 'password',
          }}
        />
        <ShowHideWrapper onClick={() => setIsVisible(!isVisible)}>
          {isVisible ? (
            <IconPswHidden width={35} height={35} />
          ) : (
            <IconPswVisible width={35} height={35} />
          )}
        </ShowHideWrapper>
      </StyledPasswordWrapper>
    </LabelWrapper>
  )
}

const StyledPasswordWrapper: React.ComponentType<
  React.ElementConfig<'div'>
> = styled.div`
  position: relative;
  width: 100%;

  input {
    padding-right: 48px;
  }

  input::-ms-reveal,
  input::-ms-clear {
      display: none;
    }
  }

  input::-webkit-credentials-auto-fill-button, input::-webkit-caps-lock-indicator, input::-webkit-textfield-decoration-container, input::-webkit-contacts-auto-fill-button  {
    visibility: hidden !important;
    display: none !important;
    pointer-events: none;
    position: absolute;
    right: 0;
  }
`

const ShowHideWrapper: React.ComponentType<
  React.ElementConfig<'div'>
> = styled.div`
  position: absolute;
  user-select: none;
  top: 8px;
  right: 10px;
  cursor: pointer;
`
